<template>
  <div class="fr">
    <span class="fr-label" :class="{ req: required }">{{ label }}</span>
    <button type="button" class="fr-value" :disabled="disabled" :aria-label="label + '：' + (text || placeholder)" @click="open = true">
      <span class="txt" :class="{ ph: !text }">{{ text || placeholder }}</span>
      <app-icon name="arrow" />
    </button>
    <datetime-sheet :show="open" :title="label" :value="value" :with-time="withTime" :clearable="clearable" :min="min" :quick="quick" @input="$emit('input', $event)" @close="open = false" />
  </div>
</template>
<script>
import DatetimeSheet from './datetime-sheet'
import { dateTimeText } from '../common/when'
export default {
  components: { DatetimeSheet },
  props: {
    label: String,
    value: { type: String, default: '' },
    withTime: { type: Boolean, default: true },
    clearable: Boolean,
    required: Boolean,
    min: { type: String, default: '' },
    quick: Boolean,
    placeholder: { type: String, default: '未安排' },
    disabled: Boolean
  },
  data() {
    return { open: false }
  },
  computed: {
    text() {
      return this.value ? dateTimeText(String(this.value).replace('T', ' ')) : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/datetime-field.vue